import React from 'react';

import AlmirahIcon from './icons/amenities/Almirah';
import BalconyIcon from './icons/amenities/Balcony';
import BarIcon from './icons/amenities/Bar';
import BathtubIcon from './icons/amenities/Bathtub';
import BreakfastIcon from './icons/amenities/Breakfast';
import CafeIcon from './icons/amenities/Cafe';
import ChargingPointIcon from './icons/amenities/Charging-point';
import ChargingIcon from './icons/amenities/Charging';
import ChildCareIcon from './icons/amenities/Child-care';
import CleaningIcon from './icons/amenities/Cleaning';
import DoctorCallIcon from './icons/amenities/Doctor-on-call';
import FreeWifiIcon from './icons/amenities/Free-wifi';
import FrizIcon from './icons/amenities/Friz';
import GymIcon from './icons/amenities/Gym';
import HeaterIcon from './icons/amenities/Heater';
import HourDeskIcon from './icons/amenities/Hour-desk';
import IndoorIcon from './icons/amenities/Indoor';
import KitchenIcon from './icons/amenities/Kitchen';
import KitchenetteIcon from './icons/amenities/Kitchenette';
import LiftIcon from './icons/amenities/Lift';
import LuggageIcon from './icons/amenities/Luggage';
import MealIcon from './icons/amenities/Meals';
import MiniBarIcon from './icons/amenities/Mini-bar';
import NonSmokingIcon from './icons/amenities/Non-smoking';
import ParkingIcon from './icons/amenities/Parking';
import PickupIcon from './icons/amenities/Pickup';
import PoolSideBarIcon from './icons/amenities/Poolside-bar';
import PrivateBathIcon from './icons/amenities/Private-bath';
import RestroIcon from './icons/amenities/Restro';
import RoomServiceIcon from './icons/amenities/Room-service';
import SafeIcon from './icons/amenities/Safe';
import SeatingAreaIcon from './icons/amenities/Seating-area';
import ShowerIcon from './icons/amenities/Shower';
import SpaIcon from './icons/amenities/Spa';
import SwimmingPoolIcon from './icons/amenities/Swimming-pool';
import TableChairIcon from './icons/amenities/Table-chair';
import ToilerPaperIcon from './icons/amenities/Toilet-paper';
import TvIcon from './icons/amenities/Tv';
import WashingMachineIcon from './icons/amenities/Washing-machine';
import WheelChairIcon from './icons/amenities/Wheel-chair';
import WorkDeskIcon from './icons/amenities/Work-desk';

import ThankYouFailIcon from './icons/hotels/ThankYouFail';
import ThankYouPendingIcon from './icons/hotels/ThankYouPending';
import ThankYouSuccessIcon from './icons/hotels/ThankYouSuccess';
import TickGreenIcon from './icons/hotels/Tick-green';
import RatingStarIcon from './icons/hotels/RatingStarIcon';
import RupeeIcon from './icons/hotels/RupeeIcon';
import CloseCircleFillIcon from './icons/hotels/CloseCircleFillIcon';
import SingleTick from './icons/hotels/SingleTick';

import FreeCancellationActive from './icons/hotels/FreeCancellationActive';
import VoucherActive from './icons/hotels/VoucherActive';

import AddGuestHeadIcon from './icons/mytrips/add-guests';
import AddGuestIcon from './icons/mytrips/addGuest';
import CalenderIcon from './icons/mytrips/calender';
import CalenderGreyIcon from './icons/mytrips/calenderGrey';
import CallHotelIcon from './icons/mytrips/callHotel';
import CancelWrongIcon from './icons/mytrips/cancel-wrong';
import CancelIcon from './icons/mytrips/cancel';
import CancelBookingIcon from './icons/mytrips/cancel-booking';
import CancelBlueIcon from './icons/mytrips/cancelBlue';
import CancelGreyIcon from './icons/mytrips/cancelGrey';
import CancelHeaderIcon from './icons/mytrips/cancelHeader';
import CancelledActiveIcon from './icons/mytrips/cancelled-active';
import CancelledIcon from './icons/mytrips/cancelled';
import CancelPartIcon from './icons/mytrips/cancelPart';
import CancelSubmitIcon from './icons/mytrips/cancelSubmit';
import CancelSuccessIcon from './icons/mytrips/cancelSuccess';
import CompletedActiveIcon from './icons/mytrips/completed-active';
import CompletedIcon from './icons/mytrips/completed';
import DetailCancelledIcon from './icons/mytrips/detail-cancelled';
import DetailedCompletedIcon from './icons/mytrips/detail-completed';
import DetailedFailedIcon from './icons/mytrips/detail-failed';
import DetailedConfirmedIcon from './icons/mytrips/detials-confirmed';
import DownloadIcon from './icons/mytrips/download';
import FailedActiveIcon from './icons/mytrips/failed-active';
import FailedIcon from './icons/mytrips/failed';
import GreenTickIcon from './icons/mytrips/greenTick';
import GuestsIcon from './icons/mytrips/guests';
import HotelCancelledIcon from './icons/mytrips/hotel-cancelled';
import HotelCompletedIcon from './icons/mytrips/hotel-completed';
import HotelFailedIcon from './icons/mytrips/hotel-failed';
import HotelUpcomingIcon from './icons/mytrips/hotel-upcoming';
import InvalidNameIcon from './icons/mytrips/invalidName';
import LocationIcon from './icons/mytrips/location';
import LogommtIcon from './icons/mytrips/logoMmt';
import NameChangeSuccessIcon from './icons/mytrips/name-change-success';
import NameChangeWrongIcon from './icons/mytrips/name-change-wrong';
import NameChangeIcon from './icons/mytrips/name-change';
import RedInfoIcon from './icons/mytrips/red-info';
import RefundBreakupIcon from './icons/mytrips/refundBreakup';
import ReviewLiveIcon from './icons/mytrips/reviewLive';
import RoomSizeIcon from './icons/mytrips/room-size';
import RoomIcon from './icons/mytrips/room';
import TrackRefundIcon from './icons/mytrips/trackRefund';
import UpcomingActiveIcon from './icons/mytrips/upcoming-active';
import UpcomingIcon from './icons/mytrips/upcoming';
import WhatsappIcon from './icons/mytrips/whatsapp';
import WhiteTickIcon from './icons/mytrips/white-tick';
import CancelledEmpty from './icons/mytrips/cancelled-empty';
import UpcomingEmpty from './icons/mytrips/upcoming-empty';
import CompletedEmpty from './icons/mytrips/completed-empty';
import ModifyHeaderSvg from './icons/mytrips/modiy-header';
import AllBookingIcon from './icons/mytrips/all-bookins';
import AllBookingActiveIcon from './icons/mytrips/all-bookings-active';
import BookingProgressIcon from './icons/mytrips/booking-progress';

import ArrowActiveIcon from './icons/mytrips/arrow-active';
import ArrowIcon from './icons/mytrips/arrow';
import ArrowBlueIcon from './icons/onboarding/Arrow-blue';
import ArrowDownIcon from './icons/onboarding/Arrow-down';
import ArrowRightDetailIcon from './icons/hotels/ArrowRightDetailIcon';
import ArrowLeftDetailIcon from './icons/hotels/ArrowLeftDetailIcon';
import WhiteArrowLeftIcon from './icons/hotels/WhiteArrowLeft';
import WhiteArrowRightIcon from './icons/hotels/WhiteArrowRight';
import MySafetyIcon from './icons/hotels/MySafety';
import MySafetyActive from './icons/hotels/MySafetyActive';

import AssistIcon from './icons/onboarding/Assist';
import BackIcon from './icons/onboarding/Back';
import CloseIcon from './icons/onboarding/Close';
import CustomerCareIcon from './icons/onboarding/Customer-care';
import EmailOtpIcon from './icons/onboarding/EmailOtp';
import FileIcon from './icons/onboarding/File';
import HomeBannerIcon from './icons/onboarding/Home-banner';
import MobileOtpIcon from './icons/onboarding/MobileOtp';
import PrivacyIcon from './icons/onboarding/Privacy';
import SearchInfoIcon from './icons/onboarding/Search-info';
import TickMarkWhiteIcon from './icons/onboarding/Tickmark-white';
import Property from './icons/onboarding/Property';
import Deal from './icons/onboarding/Deal';
import Assurance from './icons/onboarding/Assurance';
import MySafetySmallIcon from './icons/onboarding/MySafety';
import MySafetySeperator from './icons/onboarding/MySafetySeperator';
import MyLogin from './icons/onboarding/MyLogin';

import FreeCancellation from './icons/onboarding/FreeCancellation';
import SafeHygienic from './icons/onboarding/SafeHygienic';
import Sharing from './icons/onboarding/Sharing';
import PostBooking from './icons/onboarding/PostBooking';
import Confirmation from './icons/onboarding/Confirmation';

import PartnerLogoIcon from './icons/onboarding/Partner-Logo';
import PartnerLogoLightIcon from './icons/onboarding/Partner-Logo-Light';
import FlightFailedIcon from './icons/onboarding/flightfailed';

import BookingHeaderIcon from './icons/header/booking';
import LogoutHeaderIcon from './icons/header/logout';
import MoneyHeaderIcon from './icons/header/money';
import ProfileHeaderIcon from './icons/header/myprofile';
import TripsHeaderIcon from './icons/header/mytrips';
import SupportHeaderIcon from './icons/header/support';
import VideoHeaderIcon from './icons/header/video';
import WalletHeaderIcon from './icons/header/wallet';
import FlightHeadIcon from './icons/header/flightHead';
import FlightActiveHeadIcon from './icons/header/flightActiveHead';
import HotelHeadIcon from './icons/header/hotelHead';
import HotelActiveHeadIcon from './icons/header/hotelActiveHead';
import MyCashHeaderIcon from './icons/header/myCash';
import PendingRequestIcon from './icons/header/pendingRequest';
import RewardBonusHeadIcon from './icons/header/rewardBonus';

import MyCashIcon from './icons/wallet/mycash';
import RewardBonusIcon from './icons/wallet/rewardbonus';
import UpBlueArrowIcon from './icons/wallet/upbluearrow';
import DownBlueArrowIcon from './icons/wallet/downbluearrow';
import RewardBonusSmallIcon from './icons/wallet/rewardbonussmall';
import DownaloadNew from './icons/wallet/downloadNew';

import ComapnyIcon from './icons/settings/CompanyIcon';
import DeleteIcon from './icons/settings/DeleteIcon';
import EditIcon from './icons/settings/EditIcon';
import GreenMultiTickIcon from './icons/settings/GreenMultiTickIcon';
import ProfileDefaultIcon from './icons/settings/ProfileDefaultIcon';
import ProfileIcon from './icons/settings/ProfileIcon';

import LinearLoader from './icons/mytrips/linear-loader';

import MobileBlockIcon from './icons/onboarding/Mobile-block';
import WhatsApp from './icons/common/whatsapp';
import WhatsAppNormalIcon from './icons/common/normalWA';
import WhatsAppSelectedIcon from './icons/common/selectedWA';

import FlightIcon from './icons/verticals/Flight';
import HotelIcon from './icons/verticals/Hotel';
import HotelActiveIcon from './icons/verticals/HotelActive';
import FlightActiveIcon from './icons/verticals/FlightActive';

import BestClassIcon from './icons/onboarding/newHome/Best-class';
import BestRatesIcon from './icons/onboarding/newHome/Best-rates';
import ConfidentialityIcon from './icons/onboarding/newHome/Confidentiality';
import ConfirmPrintIcon from './icons/onboarding/newHome/Confirm-print';
import EasyAccessIcon from './icons/onboarding/newHome/Easy-access';
import ExpressCareIcon from './icons/onboarding/newHome/Express-care';
import NeverBeforeIcon from './icons/onboarding/newHome/Never-before';
import QuickBookIcon from './icons/onboarding/newHome/Quick-book';
import SafeAndHygienicIcon from './icons/onboarding/newHome/SafeAndHygienic';
import ShareWhatsAppIcon from './icons/onboarding/newHome/Share-whatsapp';
import WidestInventoryIcon from './icons/onboarding/newHome/Widest-inventory';
import HeaderBackIcon from './icons/common/headerBack';

import BestRatesNewIcon from './icons/onboardingNew/homepage/best-rates';
import CancelPolicyNewIcon from './icons/onboardingNew/homepage/cancel-policy';
import ConfidentialityNewIcon from './icons/onboardingNew/homepage/confidentiality';
import ConfirmPrintNewIcon from './icons/onboardingNew/homepage/confirmation-print';
import EasyAccessNewIcon from './icons/onboardingNew/homepage/easy-access';
import EasyBookingNewIcon from './icons/onboardingNew/homepage/easy-booking';
import ExpressCareNewIcon from './icons/onboardingNew/homepage/express-care';
import HygenicRoomNewIcon from './icons/onboardingNew/homepage/hygenic-room';
import WidestInventoryNewIcon from './icons/onboardingNew/homepage/widest-inventory';
import IndiaIcon from './icons/onboardingNew/homepage/india';
import LoginLogoIcon from './icons/onboardingNew/homepage/login-logo';
import SafeDiningNewIcon from './icons/onboardingNew/homepage/safe-dining';
import SafeHyenicNewIcon from './icons/onboardingNew/homepage/safe-hygenic';
import SanitizedIndoorsNewIcon from './icons/onboardingNew/homepage/sanitized-indoors';
import ShareWhatsappNewIcon from './icons/onboardingNew/homepage/share-whatsapp';
import TrainedStaffNewIcon from './icons/onboardingNew/homepage/trained-staff';
import AccountCreatedIcon from './icons/onboardingNew/signup/account-created';

import ReportIcon from './icons/report/report';
import ReportHeaderIcon from './icons/header/reportHeader';
import HolidayIcon from './icons/header/holiday';
import HolidaysIconActive from './icons/header/holidayActive';
import VisaIcon from './icons/header/visa';
import VisaActiveIcon from './icons/header/visaActive';
import TravelInsuranceIcon from './icons/header/insurance';
import TravelInsuranceActiveIcon from './icons/header/insuranceActive';

const IconSelector = ({iconKey, props = null}) => {
  switch (iconKey) {
    case 'whitearrowleft':
      return <WhiteArrowLeftIcon {...props} />;
    case 'whitearrowright':
      return <WhiteArrowRightIcon {...props} />;
    case 'rightarrow':
      return <ArrowRightDetailIcon {...props} />;
    case 'leftarrow':
      return <ArrowLeftDetailIcon {...props} />;
    case 'arrowactive':
      return <ArrowActiveIcon {...props} />;
    case 'arrow':
      return <ArrowIcon {...props} />;
    case 'arrowblue':
      return <ArrowBlueIcon {...props} />;
    case 'arrowdown':
      return <ArrowDownIcon {...props} />;

    case 'mysafety':
      return <MySafetyIcon {...props} />;
    case 'mysafetyactive':
      return <MySafetyActive {...props} />;

    case 'voucheractive':
      return <VoucherActive {...props} />;

    case 'almirah':
      return <AlmirahIcon {...props} />;
    case 'balcony':
      return <BalconyIcon {...props} />;
    case 'bar':
      return <BarIcon {...props} />;
    case 'bathtub':
      return <BathtubIcon {...props} />;
    case 'breakfast':
      return <BreakfastIcon {...props} />;
    case 'cafe':
      return <CafeIcon {...props} />;
    case 'chargingpoint':
      return <ChargingPointIcon {...props} />;
    case 'charging':
      return <ChargingIcon {...props} />;
    case 'childcare':
      return <ChildCareIcon {...props} />;
    case 'cleaning':
      return <CleaningIcon {...props} />;
    case 'doctoroncall':
      return <DoctorCallIcon {...props} />;
    case 'freewifi':
      return <FreeWifiIcon {...props} />;
    case 'friz':
      return <FrizIcon {...props} />;
    case 'gym':
      return <GymIcon {...props} />;
    case 'heater':
      return <HeaterIcon {...props} />;
    case '24hourdesk':
      return <HourDeskIcon {...props} />;
    case 'indoor':
      return <IndoorIcon {...props} />;
    case 'kitchen':
      return <KitchenIcon {...props} />;
    case 'kitchenette':
      return <KitchenetteIcon {...props} />;
    case 'lift':
      return <LiftIcon {...props} />;
    case 'luggage':
      return <LuggageIcon {...props} />;
    case 'meal':
      return <MealIcon {...props} />;
    case 'minibar':
      return <MiniBarIcon {...props} />;
    case 'nonsmoking':
      return <NonSmokingIcon {...props} />;
    case 'parking':
      return <ParkingIcon {...props} />;
    case 'pickup':
      return <PickupIcon {...props} />;
    case 'poolsidebar':
      return <PoolSideBarIcon {...props} />;
    case 'privatebath':
      return <PrivateBathIcon {...props} />;
    case 'restro':
      return <RestroIcon {...props} />;
    case 'roomservice':
      return <RoomServiceIcon {...props} />;
    case 'safe':
      return <SafeIcon {...props} />;
    case 'seatingarea':
      return <SeatingAreaIcon {...props} />;
    case 'shower':
      return <ShowerIcon {...props} />;
    case 'spa':
      return <SpaIcon {...props} />;
    case 'swimmingpool':
      return <SwimmingPoolIcon {...props} />;
    case 'tablechair':
      return <TableChairIcon {...props} />;
    case 'toiletpaper':
      return <ToilerPaperIcon {...props} />;
    case 'tv':
      return <TvIcon {...props} />;
    case 'Washingmachine':
      return <WashingMachineIcon {...props} />;
    case 'wheelchair':
      return <WheelChairIcon {...props} />;
    case 'workdesk':
      return <WorkDeskIcon {...props} />;

    case 'thankyoufail':
      return <ThankYouFailIcon {...props} />;
    case 'thankyoupending':
      return <ThankYouPendingIcon {...props} />;
    case 'thankyousuccess':
      return <ThankYouSuccessIcon {...props} />;
    case 'tickgreen':
      return <TickGreenIcon {...props} />;
    case 'ratingstar':
      return <RatingStarIcon {...props} />;
    case 'rupee':
      return <RupeeIcon {...props} />;
    case 'closecirclefill':
      return <CloseCircleFillIcon {...props} />;

    case 'addguestshead':
      return <AddGuestHeadIcon {...props} />;
    case 'arg':
      return <AddGuestIcon {...props} />;
    case 'chgn':
      return <AddGuestIcon {...props} />;
    case 'calender':
      return <CalenderIcon {...props} />;
    case 'chsd':
      return <CalenderIcon {...props} />;
    case 'calendergrey':
      return <CalenderGreyIcon {...props} />;
    case 'callhotel':
      return <CallHotelIcon {...props} />;
    case 'cancelwrong':
      return <CancelWrongIcon {...props} />;
    case 'cancel':
      return <CancelIcon {...props} />;
    case 'cb':
      return <CancelIcon {...props} />;
    case 'cfb':
      return <CancelBookingIcon {...props} />;
    case 'cancelblue':
      return <CancelBlueIcon {...props} />;
    case 'cancelgrey':
      return <CancelGreyIcon {...props} />;
    case 'cancelheader':
      return <CancelHeaderIcon {...props} />;
    case 'cancelledactive':
      return <CancelledActiveIcon {...props} />;
    case 'cancelled':
      return <CancelledIcon {...props} />;
    case 'cpb':
      return <CancelPartIcon {...props} />;
    case 'cancelsubmit':
      return <CancelSubmitIcon {...props} />;
    case 'cancelsuccess':
      return <CancelSuccessIcon {...props} />;
    case 'completedactive':
      return <CompletedActiveIcon {...props} />;
    case 'completed':
      return <CompletedIcon {...props} />;
    case 'detailcancelled':
      return <DetailCancelledIcon {...props} />;
    case 'detailcompleted':
      return <DetailedCompletedIcon {...props} />;
    case 'detailFailed':
      return <DetailedFailedIcon {...props} />;
    case 'detailconfirmed':
      return <DetailedConfirmedIcon {...props} />;
    case 'dwcv':
      return <DownloadIcon {...props} />;
    case 'dwv':
      return <DownloadIcon {...props} />;
    case 'dwi':
      return <DownloadIcon {...props} />;
    case 'cin':
      return <DownloadIcon {...props} />;
    case 'failedactive':
      return <FailedActiveIcon {...props} />;
    case 'failed':
      return <FailedIcon {...props} />;
    case 'greentick':
      return <GreenTickIcon {...props} />;
    case 'guests':
      return <GuestsIcon {...props} />;
    case 'hotelcompleted':
      return <HotelCompletedIcon {...props} />;
    case 'hotelcancelled':
      return <HotelCancelledIcon {...props} />;
    case 'hotelfailed':
      return <HotelFailedIcon {...props} />;
    case 'hotelupcoming':
      return <HotelUpcomingIcon {...props} />;
    case 'invalidname':
      return <InvalidNameIcon {...props} />;
    case 'location':
      return <LocationIcon {...props} />;
    case 'logommt':
      return <LogommtIcon {...props} />;
    case 'namechangesuccess':
      return <NameChangeSuccessIcon {...props} />;
    case 'namechangewrong':
      return <NameChangeWrongIcon {...props} />;
    case 'namechange':
      return <NameChangeIcon {...props} />;
    case 'redinfo':
      return <RedInfoIcon {...props} />;
    case 'refundbreakup':
      return <RefundBreakupIcon {...props} />;
    case 'rbr':
      return <RefundBreakupIcon {...props} />;
    case 'reviewlive':
      return <ReviewLiveIcon {...props} />;
    case 'roomsize':
      return <RoomSizeIcon {...props} />;
    case 'arr':
      return <RoomIcon {...props} />;
    case 'trackrefund':
      return <TrackRefundIcon {...props} />;
    case 'upcomingactive':
      return <UpcomingActiveIcon {...props} />;
    case 'upcoming':
      return <UpcomingIcon {...props} />;
    case 'whatsapp':
      return <WhatsappIcon {...props} />;
    case 'whitetick':
      return <WhiteTickIcon {...props} />;
    case 'cancelledempty':
      return <CancelledEmpty {...props} />;
    case 'upcomingempty':
      return <UpcomingEmpty {...props} />;
    case 'completedempty':
      return <CompletedEmpty {...props} />;
    case 'modifyheader':
      return <ModifyHeaderSvg {...props} />;
    case 'allbooking':
      return <AllBookingIcon {...props} />;
    case 'allbookingactive':
      return <AllBookingActiveIcon {...props} />;
    case 'bookingprogress':
      return <BookingProgressIcon {...props} />;

    case 'assist':
      return <AssistIcon {...props} />;
    case 'back':
      return <BackIcon {...props} />;
    case 'close':
      return <CloseIcon {...props} />;
    case 'customercare':
      return <CustomerCareIcon {...props} />;
    case 'emailotp':
      return <EmailOtpIcon {...props} />;
    case 'file':
      return <FileIcon {...props} />;
    case 'homebanner':
      return <HomeBannerIcon {...props} />;
    case 'mobileotp':
      return <MobileOtpIcon {...props} />;
    case 'partnerlogo':
      return <PartnerLogoIcon {...props} />;
    case 'partnerlogolight':
      return <PartnerLogoLightIcon {...props} />;
    case 'privacy':
      return <PrivacyIcon {...props} />;
    case 'searchinfo':
      return <SearchInfoIcon {...props} />;
    case 'tickmarkwhite':
      return <TickMarkWhiteIcon {...props} />;
    case 'property':
      return <Property {...props} />;
    case 'deal':
      return <Deal {...props} />;
    case 'assure':
      return <Assurance {...props} />;
    case 'onboardingmysafety':
      return <MySafetySmallIcon {...props} />;
    case 'freecancellation':
      return <FreeCancellation {...props} />;
    case 'freecancellationactive':
      return <FreeCancellationActive {...props} />;
    case 'safehygienic':
      return <SafeHygienic {...props} />;
    case 'sharing':
      return <Sharing {...props} />;
    case 'postbooking':
      return <PostBooking {...props} />;
    case 'confirmation':
      return <Confirmation {...props} />;
    case 'mysafetyseperator':
      return <MySafetySeperator {...props} />;
    case 'mylogin':
      return <MyLogin {...props} />;
    case 'flightfailed':
      return <FlightFailedIcon {...props} />;

    case 'bookinghead':
      return <BookingHeaderIcon {...props} />;
    case 'logouthead':
      return <LogoutHeaderIcon {...props} />;
    case 'moneyhead':
      return <MoneyHeaderIcon {...props} />;
    case 'tripshead':
      return <TripsHeaderIcon {...props} />;
    case 'profilehead':
      return <ProfileHeaderIcon {...props} />;
    case 'supporthead':
      return <SupportHeaderIcon {...props} />;
    case 'videohead':
      return <VideoHeaderIcon {...props} />;
    case 'wallethead':
      return <WalletHeaderIcon {...props} />;
    case 'flighthead':
      return <FlightHeadIcon {...props} />;
    case 'flightactivehead':
      return <FlightActiveHeadIcon {...props} />;
    case 'hotelhead':
      return <HotelHeadIcon {...props} />;
    case 'hotelactivehead':
      return <HotelActiveHeadIcon {...props} />;

    case 'holiday':
      return <HolidayIcon {...props} />;
    case 'holidayactive':
      return <HolidaysIconActive {...props} />;
    case 'visa':
      return <VisaIcon {...props} />;
    case 'visaactive':
      return <VisaActiveIcon {...props} />;
    case 'travelinsurance':
      return <TravelInsuranceIcon {...props} />;
    case 'travelinsuranceactive':
      return <TravelInsuranceActiveIcon {...props} />;

    case 'mycashhead':
      return <MyCashHeaderIcon {...props} />;
    case 'pendingrequest':
      return <PendingRequestIcon {...props} />;
    case 'rewardbonushead':
      return <RewardBonusHeadIcon {...props} />;

    case 'mycash':
      return <MyCashIcon {...props} />;
    case 'rewardbonus':
      return <RewardBonusIcon {...props} />;
    case 'downbluearrow':
      return <DownBlueArrowIcon {...props} />;
    case 'upbluearrow':
      return <UpBlueArrowIcon {...props} />;
    case 'rewardbonussmall':
      return <RewardBonusSmallIcon {...props} />;
    case 'downloadNew':
      return <DownaloadNew {...props} />;

    case 'company':
      return <ComapnyIcon {...props} />;
    case 'delete':
      return <DeleteIcon {...props} />;
    case 'edit':
      return <EditIcon {...props} />;
    case 'greenmultitick':
      return <GreenMultiTickIcon {...props} />;
    case 'profiledefault':
      return <ProfileDefaultIcon {...props} />;
    case 'profile':
      return <ProfileIcon {...props} />;
    case 'shl':
      return <LocationIcon {...props} />;

    case 'singletick':
      return <SingleTick {...props} />;

    case 'linearloader':
      return <LinearLoader props={props} />;
    case 'whatsapp-icon':
      return <WhatsApp props={props} />;
    case 'whatsappnormal':
      return <WhatsAppNormalIcon props={props} />;
    case 'whatsappselected':
      return <WhatsAppSelectedIcon props={props} />;

    case 'mobileblock':
      return <MobileBlockIcon {...props} />;

    case 'flight':
      return <FlightIcon {...props} />;
    case 'hotel':
      return <HotelIcon {...props} />;
    case 'hotelActive':
      return <HotelActiveIcon {...props} />;
    case 'flightActive':
      return <FlightActiveIcon {...props} />;

    case 'bestClass':
      return <BestClassIcon {...props} />;
    case 'bastRates':
      return <BestRatesIcon {...props} />;
    case 'confidential':
      return <ConfidentialityIcon {...props} />;
    case 'confimrPrint':
      return <ConfirmPrintIcon {...props} />;
    case 'easyAccess':
      return <EasyAccessIcon {...props} />;
    case 'expressCare':
      return <ExpressCareIcon {...props} />;
    case 'neverBefore':
      return <NeverBeforeIcon {...props} />;
    case 'quickBook':
      return <QuickBookIcon {...props} />;
    case 'safeHyg':
      return <SafeAndHygienicIcon {...props} />;
    case 'shareWhatsapp':
      return <ShareWhatsAppIcon {...props} />;
    case 'widestInventory':
      return <WidestInventoryIcon {...props} />;

    case 'headerback':
      return <HeaderBackIcon {...props} />;

    case 'bestRatesNew':
      return <BestRatesNewIcon {...props} />;
    case 'cancelPolicyNew':
      return <CancelPolicyNewIcon {...props} />;
    case 'confidentialityNew':
      return <ConfidentialityNewIcon {...props} />;
    case 'confirmationPrintNew':
      return <ConfirmPrintNewIcon {...props} />;
    case 'easyAccessNew':
      return <EasyAccessNewIcon {...props} />;
    case 'easyBookingNew':
      return <EasyBookingNewIcon {...props} />;
    case 'expressCareNew':
      return <ExpressCareNewIcon {...props} />;
    case 'hygenicRoomNew':
      return <HygenicRoomNewIcon {...props} />;
    case 'india':
      return <IndiaIcon {...props} />;
    case 'loginLogo':
      return <LoginLogoIcon {...props} />;
    case 'safeDiningNew':
      return <SafeDiningNewIcon {...props} />;
    case 'safeHygenicNew':
      return <SafeHyenicNewIcon {...props} />;
    case 'sanitizedIndoorsNew':
      return <SanitizedIndoorsNewIcon {...props} />;
    case 'shareWhatsappNew':
      return <ShareWhatsappNewIcon {...props} />;
    case 'traniedStaffNew':
      return <TrainedStaffNewIcon {...props} />;
    case 'widestInventoryNew':
      return <WidestInventoryNewIcon {...props} />;
    case 'accountCreated':
      return <AccountCreatedIcon {...props} />;

    case 'reportIcon':
      return <ReportIcon {...props} />;
    case 'reportHeadIcon':
      return <ReportHeaderIcon {...props} />;

    default:
      return null;
  }
};

export default IconSelector;
